import React from 'react';
import { componentService } from 'js/services/component.service';

export const LinkExternalAccounts = React.lazy(() => import(/* webpackChunkName: "link-external-accounts" */ './LinkExternalAccounts'));

componentService.registerPageComponents({ 'link-external-accounts': LinkExternalAccounts });
